const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogotype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:cc": "http://creativecommons.org/ns#",
    "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
    width: "21.62891mm",
    height: "5.2658081mm",
    viewBox: "0 0 21.62891 5.2658081",
    id: "svg1001",
    "inkscape:version": "0.92.3 (2405546, 2018-03-11)",
    "sodipodi:docname": "logotype.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs995"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 547.8 V 251.987 H 0 Z",
    id: "path68",
    "inkscape:connector-curvature": 0
  }))), /*#__PURE__*/React.createElement("sodipodi:namedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    "inkscape:pageopacity": 0,
    "inkscape:pageshadow": 2,
    "inkscape:zoom": 0.35,
    "inkscape:cx": 40.873516,
    "inkscape:cy": 9.951152,
    "inkscape:document-units": "mm",
    "inkscape:current-layer": "layer1",
    showgrid: "false",
    "inkscape:window-width": 2880,
    "inkscape:window-height": 1674,
    "inkscape:window-x": 0,
    "inkscape:window-y": 60,
    "inkscape:window-maximized": 1
  }), /*#__PURE__*/React.createElement("metadata", {
    id: "metadata998"
  }, /*#__PURE__*/React.createElement("rdf:RDF", null, /*#__PURE__*/React.createElement("cc:Work", {
    "rdf:about": ""
  }, /*#__PURE__*/React.createElement("dc:format", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dc:type", {
    "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dc:title", null)))), /*#__PURE__*/React.createElement("g", {
    "inkscape:label": "Layer 1",
    "inkscape:groupmode": "layer",
    id: "layer1",
    transform: "translate(92.079332,-146.20043)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,-0.35277777,-254.24771,154.57492)",
    id: "g64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g66",
    clipPath: "url(#clipPath70)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g72",
    transform: "translate(518.2122,23.7387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -7.362,-7.602 C -7.753,-8.01 -8.13,-8.217 -8.48,-8.217 c -0.111,0 -0.217,0.018 -0.321,0.036 -0.344,0.058 -0.379,0.11 -0.4,0.131 -0.098,0.099 -0.126,0.243 0.318,0.707 l 3.261,3.388 c 0.612,0.639 0.791,1.228 0.461,1.716 -0.214,0.316 -0.472,0.615 -1.784,0.857 -1.113,0.205 -1.766,0.291 -2.712,0.079 -0.991,-0.222 -1.758,-0.785 -2.37,-1.424 l -4.074,-4.277 v -3.016 l 6.534,6.823 c 0.444,0.463 0.786,0.57 0.935,0.602 0.035,0.008 0.068,0.015 0.14,0.015 0.095,0 0.217,-0.013 0.364,-0.038 0.343,-0.058 0.377,-0.112 0.399,-0.131 0.076,-0.066 0.126,-0.244 -0.318,-0.707 l -3.316,-3.462 c -0.612,-0.639 -0.743,-1.235 -0.431,-1.709 0.243,-0.369 0.596,-0.595 1.754,-0.863 0.348,-0.08 1.092,-0.177 1.451,-0.187 1.282,-0.035 2.419,0.307 3.563,1.502 l 1.494,1.56 L 2.788,0 H 0",
    style: {
      fill: "#e35049",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74",
    "inkscape:connector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g76",
    transform: "translate(471.9933,22.2717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 8.695 V -2.416 H 3.444 V -5.102 H 8.695 V -7.374 H 3.444 v -2.903 h 5.251 v -2.344 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78",
    "inkscape:connector-curvature": 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 494.146,9.651 h 3.48 v 12.621 h -3.48 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80",
    "inkscape:connector-curvature": 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "g82",
    transform: "translate(492.6516,22.2717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -2.404 L -5.127,-8.654 H -5.163 L -7.85,0 h -2.615 v -2.992 l 3.247,-9.629 h 3.937 L 0,-2.992 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84",
    "inkscape:connector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g86",
    transform: "translate(463.9989,11.9762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -0.847 V 7.897 H 0 C 2.29,7.897 3.317,6.851 3.317,3.966 3.317,1.082 2.254,0 0,0 M 6.502,6.566 C 5.704,9.079 3.546,10.295 0.162,10.295 H -4.309 V -2.326 h 4.363 c 3.481,0 5.649,1.28 6.448,3.838 v 5.054",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88",
    "inkscape:connector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g90",
    transform: "translate(499.9174,21.6505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -0.073 v -0.209 h 0.07 c 0.103,0 0.136,0.032 0.136,0.103 C 0.133,-0.03 0.089,0 0,0 m 0.182,-0.824 c -0.049,0.079 -0.065,0.109 -0.109,0.177 -0.094,0.169 -0.124,0.214 -0.146,0.234 v -0.411 h -0.264 v 1.039 h 0.416 c 0.204,0 0.334,-0.128 0.334,-0.318 0,-0.156 -0.103,-0.269 -0.239,-0.283 0.062,-0.024 0.101,-0.087 0.139,-0.142 0.073,-0.114 0.182,-0.296 0.182,-0.296 z m 0.59,0.497 c 0,0.422 -0.329,0.767 -0.734,0.767 -0.405,0 -0.734,-0.345 -0.734,-0.767 0,-0.42 0.329,-0.766 0.734,-0.766 0.405,0 0.734,0.346 0.734,0.766 m 0.278,0 c 0,-0.557 -0.454,-1.01 -1.012,-1.01 -0.557,0 -1.011,0.453 -1.011,1.01 0,0.558 0.454,1.012 1.011,1.012 0.558,0 1.012,-0.454 1.012,-1.012",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92",
    "inkscape:connector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g94",
    transform: "translate(502.6871,10.3961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-0.037 0.003,-0.07 0.011,-0.1 0.037,-0.151 0.166,-0.265 0.329,-0.265 0.24,0 0.387,0.184 0.387,0.509 0,0.281 -0.125,0.502 -0.387,0.502 C 0.189,0.646 0.048,0.532 0.011,0.37 0.003,0.336 0,0.303 0,0.266 Z m -0.576,-0.768 c 0.007,0.118 0.014,0.336 0.014,0.539 V 1.854 H 0 v -1.03 h 0.008 c 0.106,0.155 0.295,0.254 0.546,0.254 0.432,0 0.749,-0.358 0.746,-0.912 0,-0.65 -0.414,-0.974 -0.827,-0.974 -0.211,0 -0.414,0.077 -0.543,0.291 H -0.078 L -0.1,-0.768 h -0.476",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96",
    "inkscape:connector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g98",
    transform: "translate(504.751,11.434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 0.27,-0.886 C 0.299,-0.993 0.336,-1.127 0.358,-1.222 H 0.37 c 0.025,0.095 0.054,0.233 0.081,0.336 L 0.672,0 H 1.274 L 0.853,-1.189 C 0.594,-1.905 0.421,-2.194 0.218,-2.375 0.022,-2.544 -0.184,-2.603 -0.325,-2.622 l -0.118,0.476 c 0.07,0.011 0.159,0.045 0.243,0.097 0.086,0.044 0.178,0.133 0.233,0.225 0.019,0.026 0.029,0.055 0.029,0.081 0,0.019 -0.003,0.048 -0.025,0.092 L -0.624,0 H 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100",
    "inkscape:connector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g102",
    transform: "translate(507.6504,10.053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0.048,-0.011 0.125,-0.011 0.195,-0.011 0.706,-0.015 1.038,0.266 1.038,0.86 1.041,1.378 0.738,1.651 0.254,1.651 0.129,1.651 0.048,1.64 0,1.629 Z m -0.565,2.031 c 0.207,0.034 0.476,0.052 0.76,0.052 0.473,0 0.78,-0.085 1.02,-0.266 C 1.473,1.625 1.636,1.319 1.636,0.879 1.636,0.402 1.462,0.074 1.222,-0.129 0.96,-0.347 0.562,-0.451 0.074,-0.451 c -0.292,0 -0.499,0.019 -0.639,0.037 v 2.445",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104",
    "inkscape:connector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g106",
    transform: "translate(510.6275,10.4814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.295,0.003 -0.524,-0.067 -0.524,-0.284 0,-0.144 0.096,-0.214 0.221,-0.214 0.141,0 0.255,0.092 0.292,0.206 C -0.003,-0.262 0,-0.229 0,-0.196 Z M 0.066,-0.853 0.033,-0.672 H 0.022 c -0.118,-0.144 -0.303,-0.222 -0.517,-0.222 -0.365,0 -0.583,0.267 -0.583,0.554 0,0.469 0.421,0.694 1.059,0.691 v 0.025 c 0,0.097 -0.051,0.233 -0.328,0.233 -0.185,0 -0.38,-0.063 -0.499,-0.136 l -0.103,0.362 c 0.125,0.07 0.373,0.158 0.701,0.158 0.602,0 0.794,-0.354 0.794,-0.779 v -0.627 c 0,-0.174 0.008,-0.341 0.027,-0.44 H 0.066",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108",
    "inkscape:connector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g110",
    transform: "translate(511.6466,10.8579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,0.225 -0.008,0.417 -0.015,0.576 H 0.473 L 0.498,0.329 H 0.51 c 0.073,0.114 0.258,0.288 0.557,0.288 0.369,0 0.646,-0.244 0.646,-0.776 V -1.23 H 1.152 v 1.001 C 1.152,0.003 1.071,0.162 0.868,0.162 0.713,0.162 0.62,0.055 0.583,-0.048 0.568,-0.081 0.562,-0.137 0.562,-0.189 V -1.23 H 0 V 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path112",
    "inkscape:connector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g114",
    transform: "translate(513.9033,9.628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 1.392 H -0.236 V 1.806 H 0 v 0.07 c 0,0.218 0.067,0.458 0.229,0.605 0.14,0.133 0.336,0.181 0.498,0.181 0.126,0 0.222,-0.014 0.3,-0.036 L 1.005,2.194 C 0.956,2.208 0.897,2.219 0.824,2.219 0.639,2.219 0.561,2.075 0.561,1.898 V 1.806 H 0.923 V 1.392 H 0.565 V 0 H 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path116",
    "inkscape:connector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g118",
    transform: "translate(515.5686,10.5327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-0.311 0.129,-0.543 0.37,-0.543 0.217,0 0.357,0.218 0.357,0.543 0,0.27 -0.103,0.543 -0.357,0.543 C 0.1,0.543 0,0.266 0,0 m 1.307,0.019 c 0,-0.662 -0.469,-0.965 -0.953,-0.965 -0.527,0 -0.934,0.348 -0.934,0.931 0,0.584 0.385,0.957 0.964,0.957 0.554,0 0.923,-0.38 0.923,-0.923",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path120",
    "inkscape:connector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g122",
    transform: "translate(517.2491,10.1195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.103,-0.063 0.318,-0.137 0.484,-0.137 0.17,0 0.24,0.059 0.24,0.152 0,0.092 -0.056,0.136 -0.266,0.207 -0.373,0.125 -0.517,0.328 -0.513,0.543 0,0.335 0.288,0.59 0.734,0.59 0.211,0 0.399,-0.048 0.51,-0.103 L 1.089,0.864 C 1.008,0.908 0.853,0.967 0.698,0.967 0.562,0.967 0.484,0.912 0.484,0.819 0.484,0.735 0.554,0.691 0.776,0.613 1.119,0.495 1.263,0.321 1.267,0.055 1.267,-0.281 1,-0.528 0.484,-0.528 c -0.237,0 -0.447,0.052 -0.584,0.125 L 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path124",
    "inkscape:connector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g126",
    transform: "translate(518.8819,10.1195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.103,-0.063 0.318,-0.137 0.484,-0.137 0.17,0 0.24,0.059 0.24,0.152 0,0.092 -0.056,0.136 -0.266,0.207 -0.373,0.125 -0.517,0.328 -0.513,0.543 0,0.335 0.288,0.59 0.734,0.59 0.211,0 0.399,-0.048 0.51,-0.103 L 1.089,0.864 C 1.008,0.908 0.853,0.967 0.698,0.967 0.562,0.967 0.484,0.912 0.484,0.819 0.484,0.735 0.554,0.691 0.775,0.613 1.119,0.495 1.263,0.321 1.267,0.055 1.267,-0.281 1,-0.528 0.484,-0.528 c -0.237,0 -0.447,0.052 -0.584,0.125 L 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path128",
    "inkscape:connector-curvature": 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotype);
export default __webpack_public_path__ + "static/media/logotype.3f75d3fd29e956825f311f4e4ec3df70.svg";
export { ForwardRef as ReactComponent };